
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parkingat/[friendlyUrl]",
      function () {
        return require("private-next-pages/parkingat/[friendlyUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parkingat/[friendlyUrl]"])
      });
    }
  